import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { RoleSelection } from "./roleSelection";
import styles from "./styles.scss";

function AccessInput({ value, input }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.accessInput}>
      <p className={styles.title}>
        {t("secondaryCriteriaTemplate.form.accessRoles.label")}
      </p>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("secondaryCriteriaTemplate.form.accessRoles.read")} :
        </p>
        <div>
          <RoleSelection
            selectedRoleIds={value.read}
            select={(role) =>
              input({
                ...value,
                read: [...value.read, role.name],
              })
            }
            unSelect={(role) =>
              input({
                ...value,
                read: value.read.filter(
                  (id) => id !== role.uuid && id !== role.name,
                ),
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("secondaryCriteriaTemplate.form.accessRoles.write")} :
        </p>
        <div>
          <RoleSelection
            selectedRoleIds={value.write}
            select={(role) =>
              input({
                ...value,
                write: [...value.write, role.name],
              })
            }
            unSelect={(role) =>
              input({
                ...value,
                write: value.write.filter(
                  (id) => id !== role.uuid && id !== role.name,
                ),
              })
            }
          />
        </div>
      </div>
    </div>
  );
}

export { AccessInput };
